import {
    RAISE_TICKET_REQUEST,
    RAISE_TICKET_SUCCESS,
    RAISE_TICKET_ERROR,
    RAISE_TICKET_ERROR_RESET
} from '../actionType';

const initialState = {
    ticketResponse: null,
    ticketResponseError: null,
    formData: null,
    ticketResponseId: null
}

const tikectReducer = (state = initialState, action: any) => {
    const { type, payload } = action

    switch (type) {
        case RAISE_TICKET_REQUEST:
            return {
                ...state,
                formData: action
            }
        case RAISE_TICKET_SUCCESS:
            return {
                ...state,
                ticketResponse: payload,
                ticketResponseId:payload // for back handle 
            }
        case RAISE_TICKET_ERROR:
            return {
                ...state,
                ticketResponseError: payload
            }
        case RAISE_TICKET_ERROR_RESET:
            return {
                ...state,
                ticketResponseError: null,
                ticketResponse:null
            }
        default:
            return state
    }
}

export default tikectReducer;